import React from 'react'

import { compose, withProps } from "recompose" 
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import superStyles from './superStyles.json'
import iconLocation from './icon-location.svg'

const VenueMap = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD7i8LfUxjqF7zGynMXR4yA8qGILU5W5RY",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `464px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={17}
    defaultCenter={{ lat: -34.606596, lng: -58.4128687 }}
    defaultOptions={{ styles: superStyles }}
  >
    {props.isMarkerShown && <Marker position={{ lat: -34.606596, lng: -58.4128687 }} icon={iconLocation} />}
  </GoogleMap>
)

export default VenueMap;


// WEBPACK FOOTER //
// ./src/components/VenueMap/index.js